// extracted by mini-css-extract-plugin
export var explainable = "_gi-a";
export var printerCard = "_gi-1";
export var printerCardConfigured = "_gi-2";
export var printerCardError = "_gi-3";
export var printerCardsContainer = "_gi-0";
export var printerIcon = "_gi-8";
export var printerIconConfigured = "_gi-5";
export var printerIconContainer = "_gi-4";
export var printerIconError = "_gi-6";
export var printerIconUnconfigured = "_gi-7";
export var workstationsTableCard = "_gi-9";